import { render, staticRenderFns } from "./EditorInstructionsModal.vue?vue&type=template&id=5d58a0d9"
import script from "./EditorInstructionsModal.vue?vue&type=script&lang=js"
export * from "./EditorInstructionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports